import React from 'react';
import { SearchCircleIcon } from '@heroicons/react/outline';
import ModernHeader from './modern/ModernHeader';

// Board-specific bits only; the design is shared (src/components/modern, 2026-10-02 refresh).
export default function Header() {
  return <ModernHeader logo={<SearchCircleIcon className="h-9 w-9 text-primary" aria-hidden="true" />} />;
}
